/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consent_Settings_LinkInputs */

const da_consent_settings_link = /** @type {(inputs: Consent_Settings_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookieindstillinger`)
};

/** @type {(inputs: Consent_Settings_LinkInputs) => LocalizedString} */
const en_consent_settings_link = da_consent_settings_link;

/**

* @param {Consent_Settings_LinkInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const consent_settings_link = /** @type {((inputs?: Consent_Settings_LinkInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consent_Settings_LinkInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_consent_settings_link(inputs)
	return /** @type {LocalizedString} */ ("Cookieindstillinger")
});